export default "__VITE_ASSET__DPKI9vwx__"